import { render, staticRenderFns } from "./SignatureCertificate.vue?vue&type=template&id=24c16c90&scoped=true&"
import script from "./SignatureCertificate.vue?vue&type=script&lang=js&"
export * from "./SignatureCertificate.vue?vue&type=script&lang=js&"
import style0 from "./SignatureCertificate.vue?vue&type=style&index=0&id=24c16c90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c16c90",
  null
  
)

export default component.exports